import { useContext } from 'react';
import TrackWrapper from '@/common/TrackWrapper';
import { contentWithNavStyles, TileGrid } from '@/new-cars/new-cars.styles';
import DoorsCard from '~/components/new-cars/DoorsSection/DoorsCard';
import SectionName from '~/constants/new-cars/SectionName';
import { SECTION_VIEW_THRESHOLD } from '~/constants/new-cars/sectionViewThreshold';
import ParentModelContext from '~/context/new-cars/ParentModelContext';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import isDoorsResult from '~/utilities/new-cars/isDoorsResult';

const viewEvent = {
  customAttributes: {
    action: 'viewed',
    level: 'Doors',
    section: 'Doors'
  },
  eventName: 'New Cars'
};

type OwnProps = {
  heading?: string;
};

function DoorsSection({ heading }: OwnProps) {
  const { modelVersions, selectedDoors, selectedParentModel } =
    useContext(ParentModelContext);

  const { parentModel } = selectedParentModel;
  const displayHeading =
    heading ?? (parentModel ? `Select a ${parentModel}` : 'Select a Model');

  return (
    <TrackWrapper
      aria-labelledby="doors-section-heading"
      element="section"
      event={viewEvent}
      threshold={SECTION_VIEW_THRESHOLD}
      trackOnce
      className={contentWithNavStyles}
    >
      <h2 className="text-text-strong t-heading-xl" id="doors-section-heading">
        {displayHeading}
      </h2>
      <TileGrid withNav>
        {modelVersions.data.results.filter(isDoorsResult).map(door => (
          <DoorsCard
            key={door.title}
            door={door}
            selected={selectedDoors?.doorCount === door.next.doorCount}
          />
        ))}
      </TileGrid>
    </TrackWrapper>
  );
}

export default withErrorBoundary<OwnProps>(
  DoorsSection,
  undefined,
  undefined,
  SectionName.Doors
);
